import { render, staticRenderFns } from "./Carts.vue?vue&type=template&id=35c571de&scoped=true"
import script from "./Carts.vue?vue&type=script&lang=js"
export * from "./Carts.vue?vue&type=script&lang=js"
import style0 from "./Carts.vue?vue&type=style&index=0&id=35c571de&prod&lang=scss&scoped=true"
import style1 from "./Carts.vue?vue&type=style&index=1&id=35c571de&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c571de",
  null
  
)

export default component.exports